import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Crown } from "lucide-react";
import { getPremiumInfo, getPremiumMarket } from "@/services/api";
import { LoadingState } from "@/components/StateViews";
import { PremiumView } from "@/components/premium/PremiumView";
import { PremiumLock } from "@/components/premium/PremiumLock";
import { YesterdayPass } from "@/components/premium/YesterdayPass";

function MyMarkets({ mine, onSel }) {
  if (!mine?.length) return null;
  const fmt = (u) => new Date(u).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  return (
    <div data-testid="premium-mine" className="flex flex-wrap items-center gap-1.5 rounded-xl bg-emerald-600/10 p-2 text-xs">
      <b className="mr-1 text-emerald-700">Mere Premium market:</b>
      {mine.map((m) => (
        <button key={m.category_id} type="button" data-testid={`premium-mine-${m.category_id}`} onClick={() => onSel(m.category_id)}
          className="rounded-full bg-emerald-600 px-2.5 py-1 font-bold text-white">{m.name} · till {fmt(m.until)}</button>
      ))}
    </div>
  );
}

export default function PremiumGuessing() {
  const [params, setParams] = useSearchParams();
  const [info, setInfo] = useState(null);
  const [d, setD] = useState(null);
  const sel = params.get("m") || info?.markets?.[0]?.category_id;

  const loadInfo = useCallback(() => getPremiumInfo().then(setInfo).catch(() => setInfo({ markets: [] })), []);
  const loadMarket = useCallback(() => { if (sel) { setD(null); getPremiumMarket(sel).then(setD).catch(() => setD({ error: true })); } }, [sel]);
  useEffect(() => { loadInfo(); }, [loadInfo]);
  useEffect(() => { loadMarket(); }, [loadMarket]);
  useEffect(() => { document.title = "Premium Guessing — Ank Mix, Jodi, Panel, Sangam | BGR MATKA"; }, []);
  const refresh = () => { loadInfo(); loadMarket(); };

  if (!info) return <LoadingState />;
  return (
    <div data-testid="premium-page" className="mx-auto max-w-6xl space-y-4 px-4 py-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="flex items-center gap-2 font-display text-3xl font-black sm:text-4xl"><Crown className="h-8 w-8 text-amber-500" /> Premium Guessing</h1>
      </div>
      <YesterdayPass />
      <MyMarkets mine={info.mine} onSel={(id) => setParams({ m: id })} />
      <div data-testid="premium-markets" className="flex gap-1.5 overflow-x-auto pb-1">
        {info.markets.map((m) => (
          <button key={m.category_id} type="button" data-testid={`premium-market-${m.category_id}`} onClick={() => setParams({ m: m.category_id })}
            className={`shrink-0 rounded-full border px-3 py-1.5 text-xs font-bold transition-colors ${sel === m.category_id ? "border-transparent bg-[color:var(--accent-maroon)] text-white" : "border-[color:var(--border-gold)] hover:bg-[color:var(--bg-secondary)]"}`}>
            {m.name}{info.mine?.some((x) => x.category_id === m.category_id) && " 👑"}{m.free && <span className="ml-1 rounded bg-emerald-600 px-1 text-[9px] text-white">FREE</span>}
          </button>
        ))}
      </div>
      <section className="gold-border rounded-2xl bg-[color:var(--bg-card)] p-4 sm:p-6">
        {!d ? <LoadingState /> : d.error ? <p className="text-sm text-red-600">Could not load, please try again.</p>
          : d.locked ? <PremiumLock d={d} onDone={refresh} />
            : <><h2 className="mb-3 font-display text-lg font-extrabold">{d.name}</h2><PremiumView d={d} /></>}
      </section>
    </div>
  );
}
